import { useFlags, useLDClient, withLDProvider } from 'launchdarkly-react-client-sdk';
import React, { useEffect } from 'react';
import { ldConfig } from './launchDarklyConfig';

export const useFeatureFlag = (
  flagName: string,
  defaultValue: any,
  contextKind = 'user',
  // additional attributes for even more control - this is customizable
  contextDetails = {}
) => {
  const flags = useFlags();
  const ldClient = useLDClient();

  useEffect(() => {
    let context: any;
    if (!ldClient) return;
    if (contextKind === 'anonymous') {
      context = ldConfig.context;
    } else {
      context = {
        kind: contextKind,
        key: ldConfig.context?.key,
        location: ldConfig?.context?.location,
        ...contextDetails
      };
    }
    ldClient?.identify(context);
  }, [ldClient, contextDetails, contextKind]);
  const flagValue = flags[flagName] !== undefined ? flags[flagName] : defaultValue;
  return flagValue;
};

export const FeatureFlagWrapper = (wrappedComponent: React.ComponentType) => {
  return withLDProvider({
    clientSideID: ldConfig.clientSideId,
    context: ldConfig.context
  })(wrappedComponent);
};
